// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__Se8u2","content":"Consent_content__2jE-Q","footer":"Consent_footer__D0Umx"};